import { createApp } from "vue";
import App from "./App.vue";
import router from "./router.js";
import clickOutside from './clickOutside.js';
import SwiperPlugin from './plugins/swiper.js';
import mitt from 'mitt';
const eventBus = mitt();  
const app = createApp(App);
app.use(router);
app.directive('click-outside', clickOutside);
app.use(SwiperPlugin);
app.config.globalProperties.$eventBus = eventBus;
app.mount("#app");